import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { setInfo } from '../../../redux/actionList';
import { Button } from 'react-bootstrap';
import DropDownOptionCard from '../../shared-components/drop_down_option_card';
import InvestmentInformationText from './datasets/investment_type_info_text';
import InvestmentTransactionHistory from './investment_transaction_history';
import InvestmentPortfolioDisplayCard from './investment_portfolio_display_card';
import setInvestmentText from './objects/set_investment_text';
import changeBuyTranToHistoryFormat from './objects/change_buy_tran_to_history_format';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    prevProcess: state.prevProcess,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class InvestmentTransactionHistoryModal extends Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {
            open: false, 
            investmentMonthlyLoaded: false,
            moneyBuildInfoArr: InvestmentInformationText,
            rerender: false
        };
        this.displayPortfolio = false;
        this.previousProcess = "";
        this.historySummaryOut = [];
        this.taxHistorySummaryOut = [];
        this.initializeInformation();
    }

    initializeInformation(){
        this.previousProcess = this.props.prevProcess;
        this.reformatHistory();
        this.createHistorySummaryArr();
    }

    reformatHistory(){
        this.investTypeArr = [];
        this.historyTranArr = [];
        this.taxHistoryArr = [];
        this.taxHistorySummaryArr = [];
        if (this.moneyBuildInfo.gameInvestments){
            for (let i=0; i< this.moneyBuildInfo.gameInvestments.length; i++){
                const gameInvestment = this.moneyBuildInfo.gameInvestments[i];
                this.investTypeArr.push({investType: gameInvestment.investType, 
                    historyExists: gameInvestment.historyExists,});
                let transactionArr = changeBuyTranToHistoryFormat(gameInvestment.transactionArr, 
                    this.moneyBuildInfo.investmentMasterData);
                let historyTranArr = gameInvestment.historyTranArr;
                historyTranArr = historyTranArr.concat(transactionArr);
                historyTranArr.sort((a, b) => (+a.transNbr > +b.transNbr) ? 1 : -1);
                for (let j=0; j<historyTranArr.length; j++){
                    const historyTran = historyTranArr[j];
                    const investmentName = historyTran.investmentName;
                    const historyObj = {investType: gameInvestment.investType, 
                        investmentName: investmentName, rcdType: "tran", ...historyTran };
                    this.historyTranArr.push(historyObj);
                }
                let taxHistoryArr = gameInvestment.taxHistoryArr;
                this.tranNbr = 99999990;
                for (let j=0; j<taxHistoryArr.length; j++){
                    this.tranNbr += j;
                    const taxHistory = gameInvestment.taxHistoryArr[j];
                    this.buildTaxHistoryByYear(taxHistory, gameInvestment.investType);
                    this.buildTaxHistoryByYear(taxHistory, gameInvestment.investType, "all");
                }
            }
        }
    }
    
    buildTaxHistoryByYear(taxHistory, investType, tranYear){
        //  creates two arrays:
        //  taxHistoryArr will contain summary records by type of tax, year and investment type 
        //      and a grand total (all years) by invest type
        //  taxHistorySummaryArr will contain summary records by type of tax, year and a grand total
        //       (all years)
        //  type of tax is either "Federal Income Tax", or "Capital Gains Tax" (taxLongText)
        if (!tranYear){
            tranYear = taxHistory.datePaid.split("-")[0];
        }
        const investmentName = taxHistory.taxLongText;
        let searchArg = investmentName + investType + tranYear;
        let dateClosed = taxHistory.datePaid;
        if (tranYear === "all"){
            dateClosed = "";
        }
        let indx = this.taxHistoryArr.findIndex(elem => elem.investmentName + elem.investType + elem.year  
            === searchArg);
        if (indx === -1){
            const historyObj = {investType: investType, year: tranYear, dateClosed: dateClosed, quantity: "",
                buyAmount: "", sellAmount: "", totalGainLoss: +taxHistory.taxAmount, transNbr: this.tranNbr,
                investmentName: investmentName, rcdType: "tax" }
            this.taxHistoryArr.push(historyObj);
        }else{
            this.taxHistoryArr[indx].totalGainLoss += +taxHistory.taxAmount;
        }
      
        searchArg = investmentName + tranYear;
        let sumIndx = this.taxHistorySummaryArr.findIndex(elem => elem.investType + elem.year  === 
            searchArg);
        if (sumIndx === -1){
            const historySummaryObj = {investType: investmentName, year: tranYear, 
                totalInitialValue: "", totalCurrentValue: "", totalGainLoss: +taxHistory.taxAmount }
            this.taxHistorySummaryArr.push(historySummaryObj);
        }else{
            this.taxHistorySummaryArr[sumIndx].totalGainLoss += +taxHistory.taxAmount;
        }
    }
    
    createHistorySummaryArr(){
        this.historySummaryArr = [];
        for (let i=0; i<this.historyTranArr.length; i++){
            let historyTran = this.historyTranArr[i];
            this.buildHistoryByYear(historyTran);
            this.buildHistoryByYear(historyTran, "", "Total Amount");
            this.buildHistoryByYear(historyTran, "all");
            this.buildHistoryByYear(historyTran, "all", "Total Amount");
        }
        this.historySummaryArr.sort((a,b) => (a.investType > b.investType) ? 1: -1);
       
        // Extract unique years, excluding 'all'
        const uniqueYears = Array.from(
            new Set(this.historySummaryArr.map(item => item.year).filter(year => year !== 'all'))
        );
        // Condition to show the filter (more than 1 actual year)
        this.closedYearOptionsArr = [];
        this.showYearFilter = uniqueYears.length > 1;
        const closedYearObj = {value: "all", selection: "no filter applied"};
        this.closedYearOptionsArr.push(closedYearObj);
        for (let i=0; i<uniqueYears.length; i++){
            const closedYearObj = {value: uniqueYears[i], selection: uniqueYears[i]};
            this.closedYearOptionsArr.push(closedYearObj);
        }
       // this.addAfterTaxAmts();
        if (this.historySummaryArr.length > 0){
            this.historySummaryOut = this.historySummaryArr.filter(item => item.year === "all");
            this.displayPortfolio = true;
        }
        if (this.taxHistorySummaryArr.length > 0){
            this.taxHistorySummaryOut = this.taxHistorySummaryArr.filter(item => item.year === "all");
            this.displayPortfolio = true;
        }
    }

buildHistoryByYear(historyTran, tranYear, investType){
   
    if (!tranYear || tranYear === ""){
        tranYear = historyTran.dateClosed.split("-")[0];
    }
    if (!investType){
        investType = historyTran.investType;
        const investmentTextObj = setInvestmentText(investType);
        if (investmentTextObj.headingText){
            investType = investmentTextObj.headingText + "s";
        }
    }
    const investTypeYear = investType + tranYear;
    const indx = this.historySummaryArr.findIndex(elem => elem.investType + elem.year === investTypeYear);
    if (indx === -1){
        const historySummaryObj = {investType: investType, year: tranYear,
            totalInitialValue: +historyTran.buyAmount, totalCurrentValue: +historyTran.sellAmount,
            totalGainLoss: +historyTran.totalGainLoss }
        this.historySummaryArr.push(historySummaryObj);
    }else{
        this.historySummaryArr[indx].totalInitialValue += +historyTran.buyAmount;
        this.historySummaryArr[indx].totalCurrentValue += +historyTran.sellAmount;
        this.historySummaryArr[indx].totalGainLoss += +historyTran.totalGainLoss;
    }
}

addAfterTaxAmts(){
     const beforeTaxAmts = this.historySummaryArr.filter(item => item.investType === "Total Amount");
     for (let i=0; i<beforeTaxAmts.length; i++){
          const beforeTax = beforeTaxAmts[i];
          const year = beforeTax.year;
          const searchArg1 = year + "Federal Income Tax";
          const taxAmtSummary1 = 
                this.taxHistorySummaryArr.find(elem => elem.year + elem.investType === searchArg1);
          const searchArg2 = year + "Capital Gains Tax";
          const taxAmtSummary2 = 
                this.taxHistorySummaryArr.find(elem => elem.year + elem.investType === searchArg2); 
           let taxAmt = 0;
           if (taxAmtSummary1 || taxAmtSummary2){
                 if (taxAmtSummary1){
                     taxAmt += +taxAmtSummary1.totalGainLoss;
                }
                if (taxAmtSummary2){
                    taxAmt += +taxAmtSummary2.totalGainLoss;
                }
            const afterTaxAmt = +beforeTax.totalGainLoss + taxAmt;
            const historySummaryObj = {investType: "Total After Tax", year: beforeTax.year, 
            totalInitialValue: "", totalCurrentValue: "", totalGainLoss: afterTaxAmt }
            this.taxHistorySummaryArr.push(historySummaryObj);
        }
    }
}
    
goToNextProcess(newProcess){
    // resetting so that the investment info will be recreated when it goes back to gameView
    if (newProcess === "back"){
        if (this.prevProcess !== ""){
            this.newProcess = this.previousProcess;
        }else{
            this.newProcess = "unlocked-features";
        }
    }else{
        this.props.setInfoRedux(true, "refreshInvestments");
        this.newProcess = newProcess;
    }
    this.props.onNavigate(this.newProcess);
}
   
filterTransactionSummary(filterYear){
    this.historySummaryOut = this.historySummaryArr.filter(item => item.year === filterYear);
    this.taxHistorySummaryOut = this.taxHistorySummaryArr.filter(item => item.year === filterYear);
    this.setState({rerender: !this.state.rerender});
}

    render() {
        this.yearOptions = this.closedYearOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
        this.portfolioDisplay = this.historySummaryOut.map((portfolioItem, index) =>
            <InvestmentPortfolioDisplayCard key={index} portfolioInfo={portfolioItem}
                 />
        );
        this.portfolioTaxDisplay = this.taxHistorySummaryOut.map((portfolioItem, index) =>
            <InvestmentPortfolioDisplayCard key={index} portfolioInfo={portfolioItem}
                   />
        );
        this.investTypeInfo =  this.investTypeArr.map((investType, index) =>
            <InvestmentTransactionHistory key={index} investInfo={investType} 
                historyTranArr={this.historyTranArr}
                taxHistoryArr={this.taxHistoryArr}
                currentGameDate={this.moneyBuildInfo.gameData.currentGameDate}
                gameID={this.moneyBuildInfo.gameData._id}
                processError = {(errorObj) => this.props.processError(errorObj)}
            />
        );
       
        const defaultImgSrc = "./assets/UnlockedFeatures/investments.png"
    return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="xl" scrollable="true"
            dialogClassName={this.gutters} animation={false}>
            <Modal.Header className="backgroundTopBottom" closeButton>
                <Modal.Title className="text-center">Investment Transaction History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="overflow-scroll mx-4 mb-5">
                      <div style={{ overflowX: 'hidden' }}>
                        <h5 className="text-center">Investment History Summary By Type</h5>
                    <span>
                        {this.showYearFilter  ?
                            <div className="text-right mr-4">
                                <label className="filter-label" htmlFor="investYear">
                                    Year Closed:&nbsp;&nbsp;
                                </label>
                                <select
                                    id="investYear"
                                    onChange={(val) => this.filterTransactionSummary(val.target.value)}
                                    className="filter-select small-select" >
                                {this.yearOptions}
                                </select>
                            </div>
                        :
                            null
                        }
                        <div className="row">
                            <div className="col-sm-2 mt-4">
                                <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo"/>
                            </div>
                            <div className="col-sm-10">                        
                                <table className="center-table table-hover table-no-space table mt-4">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Invest Type</th>
                                            <th className="text-center">Total Buy Value</th>
                                            <th className="text-center">Total Sell Value</th>
                                            <th className="text-center">Total Profit/Loss</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.portfolioDisplay}
                                        {this.portfolioTaxDisplay}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-2"></div>
                            <div className="col-sm-10">
                                For investments, this will display 'closed transactions'.&nbsp;
                                A closed transaction is created when an investment is sold or when
                                coupons or dividends are paid for the given investment.  This reflects only 
                                'realized gains' (money in your pocket).
                            </div>
                        </div>
                    </span>
                    <div className="mt-4">
                        {this.investTypeInfo}
                    </div>
                    </div>
                </div>
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                     Close
            </Button>
        </Modal.Footer>
    </Modal>
    </>
    }

}

export default  connect(mapStateToProps, mapDispatchToProps)(InvestmentTransactionHistoryModal);